import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { WindowService } from '../../../services/window.service';
import { TimeoutService } from '../../../services/timeout.service';

// NOTE: ported from GEMS LUX Angular v1 implementation of "topButton.js"
// [Anugula, Akshara - 2017.03.07]

//Timeout delay for smooth scrolling back to the top
const speed = 2000;
//How many pixels from the top before the button appears
const offset = 195;
//How large the page should be before the button appears
//Generally the smallest browser height would be ~800px
const height = 1600;

@Component({
  selector: 'gems-top-button',
  templateUrl: 'gems-top-button.component.html',
  styleUrls: ['gems-top-button.component.less'],
  standalone: false
})
export class GemsTopButtonComponent implements OnInit {
  private element: any;
  private windowService: WindowService;
  private anchor: any;

  constructor(
    private elem: ElementRef,
    private injectedWindowService: WindowService,
    private renderer: Renderer2) {

    this.element = elem.nativeElement;
    this.windowService = injectedWindowService;

  }

  ngOnInit(): void {

    this.anchor = this.elem.nativeElement.querySelector('a');
    this.renderer.listen('window', 'scroll', (evt) => {
      if (this.currentDocHeight() > height && this.currentYPosition() > offset) {
        this.anchor.classList.remove('top-button-hidden');
      } else {
        this.anchor.classList.add('top-button-hidden');
      }
    });
  }
  goTo(): void {
    this.smoothScroll();
  }

  currentYPosition(): number {
    if (window.pageYOffset) {
      return window.pageYOffset;
    }
    if (document.documentElement && document.documentElement.scrollTop) {
      return document.documentElement.scrollTop;
    }
    if (document.body.scrollTop) {
      return document.body.scrollTop;
    }
    return 0;
  };

  currentDocHeight(): number {
    return Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight);

  }

  smoothScroll(): any {
    var stopY = 0;
    var startY = this.currentYPosition();
    var speed = Math.round(speed / 100);
    var step = Math.round(startY / 25);
    var leapY = startY - step;
    var timer = 0;

    for (var j = startY; j > stopY; j -= step) {
      TimeoutService.setTimeout('window.scrollTo(0, ' + leapY + ')', timer * speed);
      leapY -= step;
      if (leapY < stopY) {
        leapY = stopY;
      }
      timer++;
    }
  };
}
